import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import React from 'react';
import { Container } from 'reactstrap';

/**
 * Subテーマベースのページ Component
 */
const SubThemePage = (props) => {

  const theme = useTheme();
  const baselineTheme = createTheme({
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          'main': {
            backgroundColor: theme.palette.background.secondary,
            marginBottom: 3,
            marginTop: 3
          },
        },
      },
    },
    typography: {
      fontFamily: [
        'system-ui', '-apple-system', "Segoe UI", 'Roboto', "Helvetica Neue", "Noto Sans", "Liberation Sans", 'Arial', 'sans-serif', "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"
      ].join(','),
    },
  });

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      error: { main: '#F9AEA5' },
    },
    components: {
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            fontSize: '14px'
          }
        }
      }
    },
  });

  return (
    <ThemeProvider theme={baselineTheme}>
      <CssBaseline />
      <ThemeProvider theme={darkTheme}>
        <Container fluid={true}>
          {props.children}
        </Container>
      </ThemeProvider>
    </ThemeProvider>
  )
}
export default SubThemePage;
